import React, {Component} from "react";
import StaticScenarioMap from "./StaticScenarioMap";
import LoadingSpinner from '../Utils/LoadingSpinner';

export class StaticScenarioEditor extends Component {

    state = {
        lla: this.props.lla,
        loading: false, // will be true when ajax request is running
    };

    handleCreateScenario = (event) => {
        this.setState({loading:true}, () => {
            const scenario = {
                type: 'lla',
                lla: this.state.lla,
            };
            this.props.simGps.submitScenario( this.props.uuid, scenario ,
                (success, result) => {
                    if( success ){
                        console.log('StaticScenarioEditor update result ' + JSON.stringify(result));
                        this.setState({loading: false});
                        this.props.onUpdated();
                    }else{
                        this.setState({loading: false});
                        console.log('Error talking to simulation data server' + result);
                    }
                });
            }
        );
        event.preventDefault();
    };

    // Called by StaticScenarioMap when pin location changes
    onLlaChange = (lla) => {
        this.setState({lla: lla});
    };

    render() {
        if( this.state.loading) {
            return ( <LoadingSpinner text="Creating static route ..." /> );
        } else {
            return (
                <div>
                    <form onSubmit={this.handleCreateScenario}>
                        <label>
                            Lat: {this.state.lla[0]}, Lon: {this.state.lla[1]}, Alt: {this.state.lla[2]}
                        </label>
                        <input type="submit" value="Submit"/>
                    </form>
                    <StaticScenarioMap lla={this.props.lla} onLlaChange={this.onLlaChange}/>
                </div>
            );
        }
    }
}

export default StaticScenarioEditor;
